import React, { useEffect, useState } from 'react';
import { defineMessages } from 'react-intl';
import { useParams } from 'react-router-dom';
import { SaveOutlined, StopOutlined } from '@ant-design/icons';
import CropImageField from '@components/common/form/CropImageField';
import { AppConstants } from '@constants';
import apiConfig from '@constants/apiConfig';
//import { restaurantType } from '@constants/masterData';
import useBasicForm from '@hooks/useBasicForm';
import useFetch from '@hooks/useFetch';
import useFetchAction from '@hooks/useFetchAction';
import useNotification from '@hooks/useNotification';
import useTranslate from '@hooks/useTranslate';
import { SelectField, TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { getCacheRes_Id } from '@services/userService';
import { restaurantActions } from '@store/actions';
import { handleRemoveImage } from '@utils';
import { Button, Col, Form, Row } from 'antd';
const message = defineMessages({
    validatePhone: 'Invalid hotline',
});
const RestaurantEditForm = (props) => {
    const { onSubmit, setIsChangedFormValues, restaurantData, setRestaurantData, onCancel, executeGet } = props;
    const translate = useTranslate();
    const params = useParams();

    const [ imageUrl, setImageUrl ] = useState();
    const [ bannerUrl, setBannerUrl ] = useState();
    const [ settings, setSettings ] = useState();
    //const resraurantTypeOption = translate.formatKeys(restaurantType, [ 'label' ]);

    const { execute: executeUpFile } = useFetch({
        ...apiConfig.file.upload,
        isRequiredTenantId: true,
    });
    const { form, mixinFuncs, onValuesChange } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });
    const restaurantId = params.restaurantId;
    const notification = useNotification();
    const { execute: update, loading } = useFetch(apiConfig.restaurant.updateByCustomer);
    const { execute: executeGetMyRestaurant } = useFetchAction(restaurantActions.getMyRestaurant, {
        loading: useFetchAction.LOADING_TYPE.APP,
    });
    const handleUpdate = (values) => {
        update({
            data: {
                ...values,
                id: restaurantData?.id,
                logoPath: imageUrl,
                bannerPath: bannerUrl,
                lang: restaurantData?.lang,
                status: restaurantData?.status,
                settings: settings,
            },
            onCompleted: (res) => {
                notification({
                    message: translate.formatMessage(commonMessage.updateRestaurantSuccess),
                });
                executeGetMyRestaurant();
                onCancel();
                executeGet({
                    pathParams: { id: restaurantId },
                    onCompleted: (response) => {
                        setRestaurantData(response?.data);
                    },
                });
                //setRestaurantData();
            },
            onError: () => {},
        });
    };
    useEffect(() => {
        if (restaurantData) {
            form.setFieldsValue({
                ...restaurantData,
            });
            setBannerUrl(restaurantData?.bannerPath);
            setImageUrl(restaurantData?.logoPath);
            setSettings(restaurantData?.settings);
        }
    }, [ restaurantData ]);
    const uploadFile = (file) => {
        executeUpFile({
            data: {
                type: 'LOGO',
                file: file,
            },
            onCompleted: (response) => {
                if (response.result === true) {
                    setImageUrl(response.data.filePath);
                }
            },
            onError: (error) => {},
        });
    };
    const uploadBanner = (file) => {
        executeUpFile({
            data: {
                type: 'LOGO',
                file: file,
            },
            onCompleted: (response) => {
                if (response.result === true) {
                    setBannerUrl(response.data.filePath);
                }
            },
            onError: (error) => {},
        });
    };
    const [ edit, setEdit ] = useState(false);
    const validatePhone = (_, value) => {
        if (value) {
            const phoneRegex = /^[\s\S]{0,20}$/;
            if (!phoneRegex.test(value)) {
                return Promise.reject(translate.formatMessage(message.validatePhone));
            }
        }
        return Promise.resolve();
    };

    return (
        <Form
            form={form}
            id={'editRestaurant'}
            onFinish={handleUpdate}
            layout="vertical"
            onChange={() => setEdit(true)}
        >
            <Row gutter={16}>
                <Col span={12}>
                    <CropImageField
                        name="logoPath"
                        label={translate.formatMessage(commonMessage.restaurantLogo)}
                        imageUrl={imageUrl && `${AppConstants.avatarRootUrl}${imageUrl}`}
                        aspect={1 / 1}
                        uploadFile={uploadFile}
                        accept="image/jpeg, image/jpg, image/gif, image/bmp, image/png"
                        handleRemoveImage={() => handleRemoveImage(setImageUrl, form)}
                    />
                </Col>
                <Col span={12}>
                    <CropImageField
                        name="banner"
                        label={translate.formatMessage(commonMessage.restaurantBanner)}
                        imageUrl={bannerUrl && `${AppConstants.avatarRootUrl}${bannerUrl}`}
                        uploadFile={uploadBanner}
                        aspect={40 / 9}
                        imgUploadedSizeAuto
                        accept="image/jpeg, image/jpg, image/gif, image/bmp, image/png"
                        handleRemoveImage={() => handleRemoveImage(setBannerUrl, form)}
                        leftIconRemove={430}
                        isBanner={true}
                    />
                </Col>
                <Col span={12}>
                    <TextField name="restaurantName" label={translate.formatMessage(commonMessage.restaurantName)} required />
                </Col>
                <Col span={12}>
                    <TextField name="restaurantPath" label={translate.formatMessage(commonMessage.restaurantPath)} required />
                </Col>
                {/* <Col span={12}>
                    <SelectField
                        disabled={true}
                        required
                        label={translate.formatMessage(commonMessage.type)}
                        name="type"
                        options={resraurantTypeOption}
                    />
                </Col> */}
                <Col span={12}>
                    <TextField
                        name="hotline"
                        label={translate.formatMessage(commonMessage.hotline)}
                        rules={[
                            {
                                validator: validatePhone,
                            },
                        ]}
                    />
                </Col>
                <Col span={12}>
                    <TextField name="zipCode" label={translate.formatMessage(commonMessage.zipCode)} />
                </Col>
                <Col span={12}>
                    <TextField name="city" label={translate.formatMessage(commonMessage.city)} />
                </Col>
                <Col span={12}>
                    <TextField name="address" label={translate.formatMessage(commonMessage.address)} />
                </Col>
            </Row>
            <div className="footer-card-form">
                <Row justify="end" gutter={12}>
                    <Col>
                        <Button danger key="cancel" onClick={onCancel} icon={<StopOutlined />}>
                            {translate.formatMessage(commonMessage.cancel)}
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            key="submit"
                            htmlType="submit"
                            type="primary"
                            form="editRestaurant"
                            icon={<SaveOutlined />}
                            disabled={!edit}
                            loading={loading}
                        >
                            {translate.formatMessage(commonMessage.update)}
                        </Button>
                    </Col>
                </Row>
            </div>
        </Form>
    );
};

export default RestaurantEditForm;
